import { cn } from "@stylingcv/utils";
import { forwardRef } from "react";

export type TextareaProps = {} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "flex min-h-24 w-full resize-y rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground transition-[color,border-color,box-shadow] focus-visible:border-primary focus-visible:outline-none focus-visible:shadow-[0_1px_3px_0_rgba(38,133,153,0.25),0_1px_2px_-1px_rgba(38,133,153,0.15)] disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = "Textarea";
